import { MutationTree } from 'vuex';
import { NodeSamlSession, NodeSamlState, AcsRedirectDetail } from './types';
import * as types from './mutation-types';
import { AppContext } from '../../../context';

export const mutations: MutationTree<NodeSamlState> = {
    // SAML認証アサーション要求受付
    [types.ACS_RECIRECT_DATA_START](state) {
        const acsRedirectDataState = state.acsRedirectData;
        acsRedirectDataState.isProcessing = true;
        acsRedirectDataState.isFetchSuccess = false;
    },

    [types.ACS_RECIRECT_DATA_SUCCESS](state, payload: AcsRedirectDetail) {
        const acsRedirectDataState = state.acsRedirectData;
        acsRedirectDataState.isProcessing = false;
        acsRedirectDataState.isFetchSuccess = true;
        state.detail = payload;
    },

    [types.ACS_RECIRECT_DATA_FAILURE](state, payload: { code: string; message: string }) {
        const acsRedirectDataState = state.acsRedirectData;
        acsRedirectDataState.errorCode = payload.code;
        acsRedirectDataState.errorMsg = payload.message;
        acsRedirectDataState.error = true;
        acsRedirectDataState.isProcessing = false;
        acsRedirectDataState.isFetchSuccess = false;
    },

    [types.SET_DATA](state, payload: NodeSamlSession) {
        localStorage.setItem(
            AppContext.InternalConfig.LocalStorage.AUTH_NODE_SAML_KEY,
            JSON.stringify({
                id: payload.id,
                relay_state: payload.relay_state,
                node_account_id: payload.node_account_id,
            })
        );
    },

    [types.CLEAR_DATA](state) {
        localStorage.removeItem(AppContext.InternalConfig.LocalStorage.AUTH_NODE_SAML_KEY);
    },
};
